import { Link } from 'react-router-dom';
import { EmptyState } from '../components/States';

export function NotFound() {
  return <EmptyState title="Página não encontrada" glyph="IM" action={<Link className="cta" to="/" style={{ display: 'inline-block', textDecoration: 'none' }}>Voltar para a visão geral</Link>}>O endereço acessado não existe nesta organização.</EmptyState>;
}
